module.exports = __webpack_public_path__ + "img/icon-copy.6eb87b52.svg";